// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import Collateral from './module';
import { routes } from './routes';

const root = {
  path: 'collateral',
  element: <Collateral />,
  children: routes,
};

export default root;
